import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TextSizeEnum} from '../../../../display-consent/enums/text-size.enum';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ChangeUnitOrderModel} from '@core/modules/rest/informationunit/request/change-unit-order.model';
import {LevelEnum} from '@core/modules/rest/indication/enums/level.enum';
import {RelevanceEnum} from "@core/modules/rest/indication/enums/relevance.enum";

@Component({
    selector: 'app-cms-menu',
    templateUrl: './cms-menu.component.html',
    styleUrls: ['./cms-menu.component.scss']
})
export class CmsMenuComponent implements OnInit {

    @Input() treeData: OutlineUnitBasicModel[] | undefined;
    @Input() currentUnitOrderId: number | undefined;
    @Input() consentId: string | undefined;
    @Input() textSize: TextSizeEnum | undefined;
    @Input() hideCloseIcon: boolean;
    @Input() showPrimaryMenuButton = false;
    @Input() primaryMenuButtonText: string | undefined;
    @Input() primaryMenuButtonIcon: string | undefined;
    @Output() closeEvent = new EventEmitter<void>();
    @Output() showElementEvent = new EventEmitter<OutlineUnitBasicModel>();
    @Output() pauseAudioEvent = new EventEmitter();
    @Output() emitPrimaryMenuButtonEvent = new EventEmitter();
    @Output() unitLevelUpEvent = new EventEmitter<OutlineUnitBasicModel>();
    @Output() unitLevelDownEvent = new EventEmitter<OutlineUnitBasicModel>();
    @Output() moveUnitEvent = new EventEmitter<ChangeUnitOrderModel>();
    @Output() unitDeleteEvent = new EventEmitter<OutlineUnitBasicModel>();
    @Output() unitRelevanceEvent = new EventEmitter<{ event: RelevanceEnum, unit: OutlineUnitBasicModel }>();

    title$: Observable<string>;

    constructor(private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.title$ = this.translate.stream('GENERAL.OUTLINE');
    }

}
